import styled from 'styled-components';
import { Link } from 'react-router-dom';
import HomeSectionCard from './homeLink';
import HomeMissionList from './homeMissionList';
import HorizontalRule from '../utils/HorizontalRule';

const Wrap = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  padding: 24px 32px 0;

  @media (max-width: 768px) {
    padding: 16px 16px 0;
  }
`;

const Eyebrow = styled.div`
  text-align: center;
  margin: 8px 0 16px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.24em;
  color: #7a8690;
  font-weight: 500;
  font-family: 'Rubik', sans-serif;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const HonorBand = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 14px;
  padding: 32px 26px;
  background: #c9b897;
  border: 1px solid #c9b897;
  text-decoration: none;
  text-align: center;
  transition: background-color 0.25s ease;

  &:hover,
  &:focus-visible {
    background: #d6c4a0;
    outline: none;
  }
`;

const HonorTitle = styled.h3`
  margin: 0;
  font-family: 'Source Serif 4', Georgia, serif;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: #1d2c33;
`;

const HonorTagline = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  color: rgba(29, 44, 51, 0.75);
`;

const TodaySection = styled.div`
  margin-top: 56px;
`;

function Home() {
  return (
    <div className='main'>
      <Wrap>
        <Eyebrow>Browse the Archive</Eyebrow>
        <Grid>
          <HomeSectionCard link="/groups" code="GRP" title="Groups" tagline="Training and operational histories of Bomber, Fighter, Recon and Transport units." />
          <HomeSectionCard link="/bases" code="BAS" title="Bases" tagline="Airfields used by the Eighth Air Force in the US and UK." />
          <HomeSectionCard link="/targets" code="TGT" title="Targets" tagline="Maps, dates, and photographs of mission targets." />
          <HomeSectionCard link="/missions" code="MSN" title="Missions" tagline="Eighth Air Force missions for any date of the war." />
          <HomeSectionCard link="/aircraft" code="A/C" title="Aircraft" tagline="The planes flown by the Eighth Air Force." />
          <HomeSectionCard link="/photos" code="PHO" title="Photos" tagline="Photographs preserved from the wartime period." />
          <HomeSectionCard link="/charts" code="CHT" title="Charts" tagline="Reference charts and informational explanations." />
          <HomeSectionCard link="/sources" code="SRC" title="Sources" tagline="Citations and source materials behind this collection." />
        </Grid>
        <HonorBand to="/honor-roll">
          <HonorTitle>Honor Roll</HonorTitle>
          <HonorTagline>A record of those who served and those who fell.</HonorTagline>
        </HonorBand>
        <TodaySection>
          <HorizontalRule text="Today in History" />
          <HomeMissionList />
        </TodaySection>
      </Wrap>
    </div>
  );
}

export default Home;
